import { render } from "./StudentAddItem.vue?vue&type=template&id=b313fc2c&scoped=true"
import script from "./StudentAddItem.vue?vue&type=script&lang=js"
export * from "./StudentAddItem.vue?vue&type=script&lang=js"

import "./StudentAddItem.vue?vue&type=style&index=0&id=b313fc2c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b313fc2c"]])

export default __exports__